<template>
  <div class="pay-list-detailed">
    <Drawer v-model="show" title="汇款转账详情" width="950">
      <div v-if="detailInfo">
        <Form :label-width="120">
          <Row>
            <FormItem label="转账流水号：" style="width: 50%">
              {{ detailInfo.recId }}</FormItem
            >
            <FormItem label="转账业务名称："
              >{{ detailInfo.busiName }}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="支出类型：" style="width: 50%"
              >{{ detailInfo.outFeeType == 3 ? '教师工资' : '其他支出' }}
            </FormItem>
            <FormItem label="转出方：">{{ detailInfo.outAcctName }} </FormItem>
          </Row>
          <Row>
            <FormItem label="转出方账号：" style="width: 50%"
              >{{ detailInfo.schoolAcctNo }}
            </FormItem>
            <FormItem label="转入方：">{{ detailInfo.inAcctName }} </FormItem>
          </Row>
          <Row>
            <FormItem label="转入方账号：" style="width: 50%"
              >{{ detailInfo.inAcctNo }}
            </FormItem>
            <FormItem label="发起时间：">{{ detailInfo.createTime }} </FormItem>
          </Row>
          <Row>
            <FormItem label="完成时间：" style="width: 50%"
              >{{ detailInfo.transStsTime }}
            </FormItem>
            <FormItem label="状态："
              >{{ getTransSts(detailInfo.transSts) }}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="金额（元）：" style="width: 50%"
              >{{ abs(detailInfo.amount) }}
            </FormItem>
            <FormItem label="操作人："> {{ detailInfo.creatorName }}</FormItem>
          </Row>
          <Row>
            <FormItem label="学期：" style="width: 50%"
              >{{ detailInfo.yearTerm }}
            </FormItem>
            <FormItem label="备注：" style="width: 50%"
              >{{ detailInfo.remark }}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="付款证明函:">
              <UploadImage ref="uploadImageRef" :view="true"></UploadImage>
              <!-- <Button type="info" @click="handleEditImage">修改证明函</Button> -->
            </FormItem>
          </Row>
        </Form>
      </div>
    </Drawer>
    <Modal v-model="modal" title="修改证明函" :width="750">
      <div class="modal-main">
        <UploadImage ref="uploadImageEditRef" :max-number="3"></UploadImage>
        <p style="color: red">
          提示：①费用支出上传付款证明函；②税金支出上传报税证明；③工资支出上传工资发放证明
        </p>
      </div>
      <div slot="footer">
        <Button style="margin-right: 16px" @click="handleClose">取消</Button>
        <Button type="primary" @click="handleCfm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import financeCenterApi from '@/request/financeCenter/index.js';
import { abs } from '@/utils/utils.js';
import UploadImage from '@c/Base/UploadImage.vue';
export default {
  name: 'PayListDetailed',
  components: {
    UploadImage
  },
  data() {
    return {
      show: false,
      modal: false,
      detailInfo: null,
      recId: ''
    };
  },
  methods: {
    abs(num) {
      return abs(num);
    },
    handleShow(recId) {
      this.recId = recId;
      this.show = true;
      this.getExpenseTransDetail(recId);
    },
    handleHide() {
      this.show = false;
    },
    async getExpenseTransDetail(recId) {
      this.detailInfo = null;
      const res = await financeCenterApi.getExpenseTransDetailApi({ recId });
      if (res.status == 200) {
        this.detailInfo = res.message;
        if (this.detailInfo.attachPhotos) {
          const ids = this.detailInfo.attachPhotos.split(',');
          this.$nextTick(() => {
            console.log(this.$refs.uploadImageRef);
            this.$refs.uploadImageRef.setIds(ids);
          });
        }
      }
    },
    getTransSts(sts) {
      const map = {
        1: '交易成功',
        2: '交易失败',
        3: '交易处理中'
      };
      return map[sts] ? map[sts] : '';
    },
    handleClose() {
      this.modal = false;
    },
    // 点击修改证明函
    handleEditImage() {
      this.modal = true;
      this.$refs.uploadImageEditRef.handleClear();
      if (this.detailInfo.attachPhotos) {
        const ids = this.detailInfo.attachPhotos.split(',');
        this.$nextTick(() => {
          this.$refs.uploadImageEditRef.setIds(ids);
        });
      }
    },
    async handleCfm() {
      if (this.$refs.uploadImageEditRef.getImgList().length == 0) {
        this.$Message.warning('请添加付款证明函');
        return null;
      }
      const ids = await this.$refs.uploadImageEditRef.getResult({
        hideLoading: false
      });
      const res = await financeCenterApi.updateAttachPhotos({
        recId: this.recId,
        attachPhotos: ids.join(',')
      });

      if (res.status == 200) {
        this.$Message.success('修改成功');
        this.modal = false;
        this.$Spin.hide();
        this.getExpenseTransDetail(this.recId);
      }
    }
  }
};
</script>

<style>
</style>
